import { createAction } from 'typesafe-actions';

export const pollBackgroundGrainBinEstimateState = createAction(
  'POLL/BACKGROUND_GRAIN_BIN_ESTIMATE_STATE',
  (resolve) => {
    return (payload: { grain_bin_id: number | null }) => resolve(payload);
  }
);
